
import modules from "@/store/index.js";
import mixin from "@/mixin/index.js";
import { loadStripe } from "@stripe/stripe-js";
const root = { root: true };
let stripePromise;

const initializeStripe = async () => {
    if (!stripePromise) {
        stripePromise = await loadStripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
    }
    return stripePromise;
};

const logEvent = (evt, params) => {
    if (false) {
        console.log(`purchases_${evt} ${params ? JSON.stringify(params) : ''} ${mixin.methods._getTimestamp()}`);
    }
    modules.dispatch(
        'general/logEvent',
        { name: evt, object: { 'uid': !!modules.getters['general/user'] ? modules.getters['general/user'].uid : '' } },
        root
    );
}

const purchasesOrder = async () => {
    logEvent("purchasesOrder", null);
    const sessionBody = {
        price: process.env.VUE_APP_STRIPE_MONTHLY_PRICE,
        success_url: process.env.VUE_APP_STRIPE_SUCCESS_URL,
        cancel_url: process.env.VUE_APP_STRIPE_CANCEL_URL
    };
    const stripe = await initializeStripe();
    modules.dispatch('purchases/createCheckoutSession', { sessionBody, stripe }, root);
}

export {
    purchasesOrder
}